import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    key: "breaksHeroBannerSection",
    props: {
        headerKey: 'Hero Banner'
    },
    fields: [
        {
            type: 'image',
            name: 'heroBannerImageId',
            idFor: 'heroBannerImage',
            required: false,
            props: {
                labelKey: 'Hero Banner Image',
                imageType: 'custom',
                helperText: 'Image for the hero banner section'
            }
        },
        {
            type: 'text',
            name: 'heroBannerHeader',
            required: false,
            props: {
                labelKey: 'Hero Banner Header',
                placeholderKey: 'Enter hero banner header text',
                validationRules: []
            }
        },
        {
            type: 'text',
            name: 'heroBannerSubHeader',
            required: false,
            props: {
                labelKey: 'Hero Banner Sub-Header',
                placeholderKey: 'Enter hero banner sub-header text',
                validationRules: []
            }
        },
        {
            type: 'text',
            name: 'heroBannerCtaCopy',
            required: false,
            props: {
                labelKey: 'Hero Banner CTA Copy',
                placeholderKey: 'Enter hero banner call-to-action copy',
                validationRules: []
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksHeroBannerSection.js